export enum EvmDashboardActionTypes {
  FETCH_EVM_DASHBOARD = "FETCH_EVM_DASHBOARD",
  FETCH_EVM_DASHBOARD_SUCCESS = "FETCH_EVM_DASHBOARD_SUCCESS",
  FETCH_EVM_DASHBOARD_FAILURE = "FETCH_EVM_DASHBOARD_FAILURE",
  FETCH_EVM_DASHBOARD_RESET = "FETCH_EVM_DASHBOARD_RESET",
}

export interface RoadmapItem {
  milestone: string;
  weekStart: string;
  weekEnd: string;
  plannedQty: number;
  executedQty: number;
  unitPrice: number;
  plannedProgress: number;
  actualProgress: number;
  budget: number;
  eac: number;
}

export interface EvmDashboardData {
  actualCost: number;
  plannedValue: number;
  earnedValue: number;
  cpi: number;
  spi: number;
  cv: number;
  sv: number;
  costBreakdown: { name: string; value: number }[];
  weeklyBreakdown: { week: string; ev: number }[];
  roadmapItems: RoadmapItem[];
}
